const actionTypes = require('constants/RAConstants/actionTypes');

const getSteps = () => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_FETCH_STEPS,
    });
};

const finishSubStep = data => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_FINALIZE_SUBSTEP,
        data,
    });
};

const finishStep = data => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_FINALIZE_STEP,
        data,
    });
};

const prevStep = data => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_PREV_STEP,
        data,
    });
};

const nextStep = data => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_NEXT_STEP,
        data,
    });
};

const goToStep = data => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_GOTO_STEP,
        data,
    });
};

const goToSubStep = data => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_GOTO_SUB_STEP,
        data,
    });
};

const retakeTest = data => dispatch => {
    dispatch({
        type: actionTypes.RA_TEST_RETAKE_TEST,
        data,
    });
};

const skipToNextStep = data => dispatch => {
    dispatch({
        type: actionTypes.RA_SKIP_TO_NEXT_TEST,
        data,
    });
};

const removeStepFromSkippedSteps = data => dispatch => {
    dispatch({
        type: actionTypes.RA_REMOVE_STEP_FROM_SKIPPED_STEPS,
        data,
    });
};

export default {
    getSteps,
    finishSubStep,
    finishStep,
    prevStep,
    nextStep,
    goToStep,
    goToSubStep,
    retakeTest,
    skipToNextStep,
    removeStepFromSkippedSteps,
};
